import * as React from 'react';
import './Spreadsheet.css';
import { getOrderValue, ItemOrderDraft, OrderStocks } from '../../domain/Order';
import DispatchProps, { mapDispatchToProps } from '../../application/core/DispatchProps';
import { connect } from 'react-redux';
import { ChangeEvent } from 'react';
import { Month } from '../admin/getEstimationMonths';
import OrderChangeRequested from '../../application/order/events/OrderChangeRequested';
import Product from '../../domain/Product';

interface Props {
    product: Product;
    model: ItemOrderDraft[];
    month: Month;
    packageSize: number;
}

class SpreadsheetOrderDetails extends React.PureComponent<Props & DispatchProps> {
    public render(): JSX.Element {
        return (
            <div className="spreadsheet-table-row-order">
                {this.props.model.map((itemOrder: ItemOrderDraft) => (
                    <div className="spreadsheet-table-row-order-size" key={itemOrder.sku}>
                        <div>
                            <span>{itemOrder.sku}</span>
                        </div>
                        <div>
                            <span>0</span>
                        </div>
                        <div>
                            {
                                // todo pass real value
                            }
                            <span>0</span>
                        </div>
                        <div>
                            <input
                                type="number"
                                min="0"
                                step={this.props.packageSize}
                                value={this.removeLeadingZeros(getOrderValue(this.props.model, itemOrder.sku, 'toOrderFromEstimation'))}
                                // tslint:disable:jsx-no-lambda
                                onChange={(event: ChangeEvent<HTMLInputElement>): void =>
                                    this.orderUpdated(event.target.value, itemOrder.sku, itemOrder.variantCode, 'toOrderFromEstimation')
                                }
                                onBlur={(event: ChangeEvent<HTMLInputElement>): void =>
                                    this.orderUpdated(
                                        event.target.value,
                                        itemOrder.sku,
                                        itemOrder.variantCode,
                                        'toOrderFromEstimation',
                                        true
                                    )
                                }
                            />
                        </div>
                        <div>
                            <input
                                type="number"
                                min="0"
                                step={this.props.packageSize}
                                value={this.removeLeadingZeros(getOrderValue(this.props.model, itemOrder.sku, 'toOrderFromStock'))}
                                // tslint:disable:jsx-no-lambda
                                onChange={(event: ChangeEvent<HTMLInputElement>): void =>
                                    this.orderUpdated(event.target.value, itemOrder.sku, itemOrder.variantCode, 'toOrderFromStock')
                                }
                                onBlur={(event: ChangeEvent<HTMLInputElement>): void =>
                                    this.orderUpdated(event.target.value, itemOrder.sku, itemOrder.variantCode, 'toOrderFromStock', true)
                                }
                            />
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    private removeLeadingZeros = (value: number): string => {
        return value.toString();
    };

    private orderUpdated = (value: string, sku: string, variantCode: string, field: keyof OrderStocks, validate?: boolean): void => {
        this.props.dispatch(new OrderChangeRequested(this.props.product, Number(value), sku, variantCode, field, validate));
    };
}

export default connect(mapDispatchToProps)(SpreadsheetOrderDetails);



// WEBPACK FOOTER //
// ./src/view/order/SpreadsheetOrderDetails.tsx